var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlechaChallenge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 35 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ECF1F1",
    d: "M0 7.308A6.832 6.832 0 0 1 6.832.476h21.336A6.832 6.832 0 0 1 35 7.308v18.335a6.832 6.832 0 0 1-6.832 6.833H6.832A6.832 6.832 0 0 1 0 25.644V7.308Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#297F87",
    d: "m17.556 20.904-.632-.633 3.399-3.403h-9.94v-.896h9.94l-3.399-3.403.632-.633 4.484 4.484-4.484 4.484Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaChallenge);
export default __webpack_public_path__ + "static/media/flecha_challenge.0f83297a658ac14581910d04573a238e.svg";
export { ForwardRef as ReactComponent };